import * as React from "react";

function Empty(): JSX.Element {
  return <p>hmm</p>;
}

export default Empty;
